import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, tap } from 'rxjs';
import { EventDTO } from '../../dto/event/event.dto';
import { environment } from '../../environment/environment';

@Injectable({
  providedIn: 'root'
})
export class DunaEventsService {
  private apiUrl = environment.apiUrl;

  constructor(private http: HttpClient) {}

  getEventByGuid(guid: string): Observable<EventDTO> {
    return this.http.get<EventDTO>(`${this.apiUrl}/events/${guid}`).pipe(
      tap({
        error: (error) => console.error('DunaEventsService: Error fetching event:', error)
      })
    );
  }

  getSubEventsByParentGuid(parentEventGuid: string): Observable<EventDTO[]> {
    return this.http.get<EventDTO[]>(`${this.apiUrl}/events/sub-events/by-guid/${parentEventGuid}`).pipe(
      tap({
        error: (error) => console.error('DunaEventsService: Error fetching sub-events:', error)
      })
    );
  }
} 